import axios from 'axios';

// History records are summaries; resuming care requires the complete scoped consultation.
export async function loadCurrentConsultation(patient, { force = false } = {}) {
  if (!patient?.agendamento_id || patient.agendamento_status !== 'Em andamento') return null;
  const cached = patient.consultaAtual;
  if (!force && cached?.id && Number(cached.agendamento_id) === Number(patient.agendamento_id) && Array.isArray(cached.agendamento?.servicos)) return cached;
  const response = await axios.get(`/api/consultas/agendamento/${patient.agendamento_id}`);
  return response.data.consulta;
}
